// extracted by mini-css-extract-plugin
export default {"LayoutWrapper":"Layout_LayoutWrapper__g4JEp","Layout":"Layout_Layout__naBXX","Content":"Layout_Content__rOmKy","Title":"Layout_Title__9bqHE"};